import React, { useEffect, useState } from "react";
import {useNavigate, useLocation } from "react-router-dom";
import Navbar from "../../../../components/navbar";
import GamingLoader from "../../../../components/gaming-loader";
import "./styles/tournament-bracket.css";
import {
  Tournament,
  TournamentTypeEnum,
} from "../../../../common/services/tournament.types";
import { useAuth } from "../../../../common/store/authStore";
import { fetchTournamentById } from "../../../../common/services/tournament";
import DoubleEliminationBracket from "./components/double-elimination-bracket";
import SingleEliminationBracket from "./components/single-elimination-bracket";

const TournamentBracket = () => {
  const [tournament, setTournament] = useState<Tournament | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const tournamentId = location.state?.tournamentId;
  const tournamentUrl = location.pathname.split('/').pop();

  const { authenticatedUser, getUserCountry } = useAuth();
  const isLoggedIn = !!authenticatedUser;
  const currentUserId = authenticatedUser?.id;
  const userCountry = getUserCountry();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login", {
        state: {
          from: `/fixtures/${tournament?.tournamentURL}`,
          message: "Please log in to view tournament fixtures.",
        },
      });
      return;
    }
  }, [isLoggedIn, navigate, tournament?.tournamentURL]);

  useEffect(() => {
    async function fetchTournamentData() {
      try {
        setLoading(true);
        const tournamentData = await fetchTournamentById(
          tournamentId || tournamentUrl,
          userCountry,
        );
        setTournament(tournamentData);
        document.title = `${tournamentData.tournamentName} - Cheda Gaming`;
      } catch {
        navigate("/tournaments");
      } finally {
        setLoading(false);
      }
    }
    fetchTournamentData();
  }, [tournamentId, userCountry, navigate, tournamentUrl]);

  const isHost = tournament?.host._id === currentUserId;

  if (loading || !tournament) {
    return <GamingLoader message="Preparing your tournament experience..." />;
  }

  if (!isHost && tournament.status !== "live" && tournament.status !== "completed") {
    return (
      <>
        <Navbar />
        <div className="stadium-loading">
          <div style={{ textAlign: "center", padding: "40px 20px" }}>
            <h2 style={{ fontSize: "24px", marginBottom: "16px", color: "#fff" }}>
              Tournament hasn't started yet
            </h2>
            <p style={{ fontSize: "16px", marginBottom: "24px", color: "#aaa" }}>
              Check back later when the tournament goes live
            </p>
            <button
              onClick={() => navigate("/tournaments")}
              style={{
                padding: "12px 24px",
                fontSize: "16px",
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              More Tournaments
            </button>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="tournament-update-container">
        {tournament.tournamentType === TournamentTypeEnum.DOUBLE_ELIMINATION ? (
          <DoubleEliminationBracket
            tournament={tournament}
          />
        ) : (
          <SingleEliminationBracket
            tournament={tournament as Tournament}
          />
        )}
      </div>
    </>
  );
};

export default TournamentBracket;
